export {
  isDefined,
  isNotDefined,
  getKey,
  hasKey,
  isFunction,
  isNumberString,
  toNumber,
  isTrue,
  isEqual,
  isWindows,
  isLinux,
  isGreater,
  checkCfg
} from "../../shared/utils";

export {
  isDataNotMinus1000,
  isDataValid,
  isNumNotNanOrInfinite,
  isFileExists,
  cartesian2polar,
  initArray,
  forgeDeepCopy,
  isPointInCircle,
  isCircleInCircle,
  getFilePath,
  stopWaiting,
  calcImgSize,
  calcZoomImg
} from "./util";
export {
  MAPSTYLES,
  DATASHAPSONMAP,
  NORMALMAPSTYLES,
  FILL_COLOR_STATUS,
  COLOR_STYLES,
  MAJMEDIANMODES,
  INVALID_1000,
  FLATCOLOR,
  STEEPCOLOR,
  FILES
} from "./consts";

export { PAGES } from "../config/pages";

export { COLOR_BAR_CONFIG } from "./colorBar-config";

export { iniWriter, iniReader } from "../js/iniReaderWriter";



// WEBPACK FOOTER //
// ./src/topography/shared/index.js